import classNames from 'classnames';

import { VoidLink } from '@/src/components/Link/VoidLink';
import type { Button as GenericButton } from '@/ui/Button/Button';

import styles from '../../List.module.scss';

interface Props extends Omit<GenericButton.Props, 'variant' | 'size'> {
    variant?: 'danger' | 'default';
    active?: boolean;
}

export function Button({ children, className, variant = 'default', active, ...props }: Props) {
    return (
        <VoidLink
            className={classNames(styles.listItem, className, {
                [styles.danger]: variant === 'danger',
                [styles.default]: variant === 'default',
                [styles.active]: active,
            })}
            role="menuitem"
            {...props}
        >
            <div className={styles.content}>{children}</div>
        </VoidLink>
    );
}
